import type { FaireProductEntity } from "../../entity_types/product";

export const p_86k3fw6h62: FaireProductEntity = {
  token: "p_86k3fw6h62",
  type: "product",
  name: "Lavender Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/b4bc004a2a383388e334f77bae0ea9215efede5cb7051b00ca793c838a8e1fda.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b277e885dfea83f7c7e1ec9f9e9f3d7e4e95f161d5f7bee42b8b3d6fd8b42bf2.jpeg",
    "https://cdn.faire.com/fastly/ef7f1cb0a4fb4b4c3a951f12525289baf114b5ad05f9637489734c1fe33ff189.jpeg",
    "https://cdn.faire.com/fastly/8d27081d7a40e77c245cbc82afb56f74a27de3824f8d15b9ae89a68ee1393d53.jpeg",
    "https://cdn.faire.com/fastly/13d7c4d4b8f551a9a795c3a927a80d88f6791ec84b0cb9b80a3c4bd12897bd15.jpeg",
    "https://cdn.faire.com/fastly/20c686cd503c208c91f217f1ace42b845fb1a6d5ef84c365dd81c616b92c81b0.jpeg",
    "https://cdn.faire.com/fastly/928b3986cc4eeede1873ed3d493b9fa66d9a4fa2dbc97d813d040504e0afefd1.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Garden Collection featuring an all-over design displaying a calming scene of bees in a field of lavender. The lavender design is replicated from original artwork painted onto burlap canvas, giving the art a unique depth and texture. Double-sided towel displays a coordinating stripe pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Lavender kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A garden-themed kitchen accessory that easily adds personal style to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:11.733Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
